<template>
    <div>
        <div class="section section_footer">
            <h2 class="section__title grey--text mb-5" data-aos="fade-up">{{ model.menu_title }}</h2>
            <div class="contact-image" data-aos="fade-up">
                <img :src="$apiHost + model.cover">
                <div class="contact-image__title" v-html="model.address"></div>
            </div>
            <google-map :name="name" class="map"/>
            <div class="container">
                <div class="contact-footer">

                    <img src="@/assets/svg/logo.svg" class="contact-footer__logo">
                    <ul class="contact-footer__socials">
                        <li>
                            <a :href="model.link_ig">
                                <img src="@/assets/svg/insta_icon.svg" alt="">
                            </a>
                        </li>
                        <li>
                            <a :href="model.link_fb">
                                <img src="@/assets/svg/fb_icon.svg">
                            </a>
                        </li>
                    </ul>
                    <v-spacer/>
                    <a :href="'mailto:' + model.email" class="contact-footer__feedback"
                    > {{ contactUs }}
                        <span class="link_b"></span>
                    </a>
                </div>
            </div>
        </div>
        <!-- <transition name="modal">
             <div class="modal"
                  v-if="this.$store.state.showForm">
                 <button class="close_modal"
                         @click="$store.state.showForm = false">
                     <img src="@/assets/svg/icon_close_b.svg" alt="icon_close_b">
                 </button>
                 <div class="modal__window" v-bind:class="{full: isFull}">
                     <img :src="image"  v-bind:class="{blur: isEn}">
                 </div>
                 <transition :duration="{ enter: 500, leave: 800 }">
                     <div class="modal__info" v-if="isEn">
                         <div v-html="article"></div>
                     </div>
                 </transition>
             </div>
         </transition>-->
    </div>
</template>

<script>
    import googleMap from '@/components/home-page-components/map/googleMap'

    export default {
        props: ['model'],
        data() {
            return {
                name: 'map',
                showForm: false,
                component: null,
                placemarks: [
                    {
                        coords: [59.9316, 30.284],
                        properties: {}, // define properties here
                        options: {}, // define options here
                        clusterName: "1"
                    }
                ]
            }
        },
        components: {
            googleMap
        },
        computed: {
            feedback() {
                return this.$store.state.feedback
            },
            contactUs() {
                if (!this.$route.params.lang) {
                    return 'Напишите нам'
                } else if (this.$route.params.lang === 'fr') {
                    return 'Contactez nous'
                } else {
                    return 'Сontact us'
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

    .section_footer {
        height: auto;
    }

    .contact-image {
        width: 100%;
        margin-bottom: 72px;
        margin-left: 10%;
        max-width: 1345px;
        @media screen and (max-width: 1024px) {
            width: 100%;
            margin-left: 0;
        }
    }

    .contact-image img {
        width: 100%;
        margin-bottom: 20px;
    }

    .contact-image__title {
        font-family: "CirceRegular", sans-serif;
        font-size: 22px;
        line-height: 1.3;
        @media screen and (max-width: 1024px) {
            width: 80%;
            margin: 0 10%;

        }
    }

    .contact-footer {
        width: 100%;
        height: 160px;
        display: flex;
        align-items: center;
    }

    .contact-footer__logo {
        width: 200px;
        margin-right: 200px;
        @media screen and (max-width: 1024px) {
            width: 100px;
            margin-right: 8px;
        }
    }

    .contact-footer__socials {
        list-style-type: none;
        padding-left: 0;
    }

    .contact-footer__socials li {
        display: inline-block;
        margin: 0 10px;
        @media screen and (max-width: 1024px) {
            margin: 0 5px;
        }
    }

    .contact-footer__socials li a {
        opacity: 1;
        transition: .3s;
        display: inline-block;
        text-decoration: none;
    }

    .contact-footer__socials li a:hover {
        opacity: .66;
    }

    .contact-footer__socials li a img {
        height: 35px;
        width: 35px;
        @media screen and (max-width: 1024px) {
            height: 20px;
            width: 20px;
        }
    }

    .contact-footer__feedback {
        text-decoration: none;
        position: relative;
        outline: none;
        color: black;
    }

    .contact-footer__feedback .link_b {
        position: absolute;
        height: 2px;
        width: 0;
        background-color: #000;
        bottom: -5px;
        transition: .4s;
        left: 0;
    }

    .contact-footer__feedback:hover .link_b {
        width: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/components/home-page-components/ContactsBlock.vue